
import * as React from 'react';
import styled from 'styled-components';

export const GridWrapper = styled.div`
    height: 72vh;
    width: 100%;

    // @media (max-height: 1080px) {
    //     height: 62vh;
    // }

    .action-menu {
        overflow: visible;
        border-bottom: none;
        line-height: 23px;
        border-color: #ccc;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        //background-color: #133366;
        background-color:  #ddd;
        // color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: bold;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .my-group-header {
        border-left: 1px solid white;
        border-right: 1px solid white;
    }

    .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
        
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #ccc;
        
    }

    .list-cell-order {
        border-left-color: transparent;
    }

    .ag-header {
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-row {
        background-color: lightgray;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
    }

    .dropdown > .dropdown-toggle {
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
        background-color: #ddd;
    }

    .ag-group-value {
        width: 100%;
    }

    .opoGroup > .opoGroupTotals {
        width: 100%;
        display: flex;
        // justify-content: space-between;
        // border: 1px solid blue;
    }

    .opoGroup > .opoGroupTotals > div {
        // flex: 1;
        //border: 1px solid red;
        text-align: center;
        // width: 11.5%;
    }

    .ag-cell-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .ag-cell-wrapper > .ag-cell-value {
        width: 100%;
    }

    @-moz-document url-prefix() {
        .ag-center-cols-viewport {
            overflow-x: hidden;
        }
    }
`;
export const LegendStyle = { height: 20,  marginRight: 5, marginLeft:30,  display: "inline-block", verticalAlign:'middle' };
export const LegendEntryStyle = { display: "inline-block", height: 20, width: 20, borderRadius: 4, border:'1px solid black' };
export const textareaNoResize: React.CSSProperties = { resize: 'none' };